import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const naira = (n) => "₦" + Number(n || 0).toLocaleString("en-NG", { maximumFractionDigits: 0 });

// Admin dashboard: the team now has more active staff than the paid plan covers.
export default function PlanOutgrownBanner() {
    const [info, setInfo] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => { api.get("/billing/status").then(({ data }) => setInfo(data.outgrown || null)).catch(() => {}); }, []);
    if (!info) return null;
    const { current_plan: cur, suggested_plan: nxt, quote, staff_count: staff } = info;

    const upgrade = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/billing/paystack/initialize", { plan_id: nxt.id, mode: "upgrade", callback_url: `${window.location.origin}/billing/callback` });
            window.location.href = data.authorization_url;
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail) || "Could not start the upgrade");
            setBusy(false);
        }
    };

    return (
        <div className="mt-8 border border-klein/25 bg-klein/5 p-5 sm:p-6 flex flex-col md:flex-row md:items-center gap-4" data-testid="plan-outgrown-banner">
            <div className="w-11 h-11 rounded-2xl bg-klein text-white flex items-center justify-center shrink-0"><TrendingUp className="w-5 h-5" /></div>
            <div className="flex-1 min-w-0">
                <div className="font-display font-bold text-lg text-ink">Your team has outgrown the {cur.name} plan</div>
                <p className="text-sm text-ink/60">
                    You have <b className="text-ink">{staff} active staff</b>; {cur.name} covers up to {cur.max_staff}.
                    {quote ? ` Upgrade to ${nxt.name} and pay only the difference for the ${quote.days_left} days left.` : ` Move to ${nxt.name} to stay covered.`}
                </p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
                {quote ? (
                    <button onClick={upgrade} disabled={busy} className="bg-klein text-white px-5 py-2.5 text-sm hover:bg-klein/90 disabled:opacity-60" data-testid="plan-outgrown-upgrade-btn">
                        {busy ? "Opening Paystack…" : `Upgrade to ${nxt.name} · ${naira(quote.amount_ngn)}`}
                    </button>
                ) : null}
                <Link to={`/billing?upgrade=${nxt.id}`} className="inline-flex items-center gap-1 text-sm font-semibold text-klein" data-testid="plan-outgrown-billing-link">
                    See plans <ArrowRight className="w-4 h-4" />
                </Link>
            </div>
        </div>
    );
}
